export const AddDays = (date: Date, days: number): Date => {
  const newDate = date.getDate() + days;
  date.setDate(newDate);
  return date;
};

export const GetDaysBetween = (startDate: Date, endDate: Date): number => {
  const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds

  return Math.round(Math.abs((startDate.valueOf() - endDate.valueOf()) / oneDay));
};

const ensureDate = (value: Date | string | null | undefined): Date | null => {
  if (!value) return null;
  if (value instanceof Date) return value;
  const isoWithoutTz = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?$/;
  if (isoWithoutTz.test(value)) {
    return new Date(value + 'Z');
  }
  return new Date(value);
};

export const toLocalDate = (value: Date | string | null | undefined): string => {
  const date = ensureDate(value);
  if (!date || isNaN(date.getTime())) return '';
  return date.toLocaleDateString('en-US', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};

export const toLocalDateTime = (value: Date | string | null | undefined): string => {
  const date = ensureDate(value);
  if (!date || isNaN(date.getTime())) return '';
  return date.toLocaleString('en-US');
};

export const toLocalDateTimePrecise = (value: Date | string | null | undefined): string => {
  const date = ensureDate(value);
  if (!date || isNaN(date.getTime())) return '';
  const base = date.toLocaleString('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });
  const ms = date.getMilliseconds().toString().padStart(3, '0');
  return `${base}.${ms}`;
};
